import React from 'react';

import PropTypes from 'prop-types';

const Spinner = ({ color, transforms, xs = false }) => {
  return (
    <div className="viewport-height-100 col-center align-center">
      <div
        role="progressbar"
        aria-valuetext="Loading..."
        style={{
          position: 'relative',
          display: ' inline-block',
          width: `${xs ? '2rem' : '4rem'}`,
          height: `${xs ? '2rem' : '4rem'}`,
          overflow: 'hidden',
          textIndent: '-999em',
          verticalAlign: 'text-bottom',
          backgroundColor: color,
          borderRadius: '50%',
          animationName: 'spinner',
          animationDuration: ' .75s',
          animationTimingFunction: 'linear',
          animationIterationCount: 'infinite',
          transform: transforms ? transforms : null,
        }}
      />
    </div>
  );
};

export default Spinner;

Spinner.propTypes = {
  color: PropTypes.string,
  transforms: PropTypes.string,
};

Spinner.defaultProps = {
  color: 'rgba(68, 68, 68, 1)',
  transforms: null,
};
